import { render, staticRenderFns } from "./DocumentFilterEditor.vue?vue&type=template&id=0333f495"
import script from "./DocumentFilterEditor.vue?vue&type=script&lang=ts"
export * from "./DocumentFilterEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports